(function () {
	"use strict";

	angular.module("swurveys.maker")
		.factory('cardListService', Handler);

		function Handler(ModalService, deleteModal, utilsService) {

			var cardListService = {};
			var defaultText = {
				content : "This is a content card. Write content here, upload an Image below, or use 'Card Type' above to change this to a question card",
				binary : "This is a two-way question. Write your question here, and write the choices in the boxes below.",
				three : "This is a three-way question. Write your question here, and write the choices in the boxes below.",
				four : "This is a four-way question. Write your question here, and write the choices in the boxes below.",
				slider : "This is a slider question. Write your question here, and write the choices in the boxes below."
			}

			cardListService.addCard = function (cb, cards) {
				var card = {
					"type": "content",
					"text": defaultText.content,
					id : utilsService.generateUUID(true)
				};

				cards.push(card);
				cb(~-cards.length);
			};

			cardListService.deleteCard = function (cb, cards, index) {
				if(index > -1) {
					//Show modal
				  deleteModal.show("Delete", "This will delete this card.").then(function (modal) {
						modal.element.modal();
						modal.close.then(function (confirm) {
							if (confirm === true) {
								cards.splice(index, 1);
		            cb(~-index);
							}
						});
			    });
			  }
			};

			cardListService.cloneCard = function (cb, cards, index) {
				if(cards.length > 9) return;

				var copyCard = JSON.parse(angular.toJson(cards[index]));

				copyCard.id = utilsService.generateUUID(true);
				cards.splice(index, 0, copyCard);
				cb(-~index);
			};

			cardListService.changeCardType = function (cb, card, index) {

				_.some(defaultText, function(text){
					if(text == card.text)
					{
						//They haven't changed the default text, so let's update it to continue being helpful
					  card.text = defaultText[card.type];
					}
				})

				if(card.type === "content") {
					delete card['top'];
					delete card['bottom'];
					delete card['left'];
					delete card['right'];
				} else {
					card.answerTemplate = 'none';
				}

				//HACK: Remove all the uneeded feilds

				if(card.type === 'slider') {
					delete card['top'];
					delete card['bottom'];
					delete card['left'];
					delete card['right'];
					card.one = card.one || {}
					card.two = card.two || {}
					card.three = card.three || {}
					card.four = card.four || {}
					card.five = card.five || {}
				} else {
					delete card['one'];
					delete card['two'];
					delete card['three'];
					delete card['four'];
					delete card['five'];
					card.right = card.right || {}
					card.left = card.left || {}

					if(card.type === 'binary') {
						delete card['top'];
						delete card['bottom'];
					} else if (card.type === 'three') {
						delete card['top'];
						card.bottom = card.bottom || {}
					}
					else {
						card.bottom = card.bottom || {}
						card.top = card.top || {}
					}
				}

				cb(undefined, undefined, card);
			};

			return cardListService;
		}

	}());
